export { default } from '@klokhuis/modules/Commons/pages/ContactUs/ContactUs.page';
